import { useEffect, useState } from 'react'
import { togglePricingPlansDialog } from '@/hooks/usePricingPlans.jsx'
import { AnalyticsService } from '@/services/analytics'

let appBannerType = null
// Optional analytics source attached to the current banner, used by the Upgrade
// CTA to fire clicked_upgrade_from_limit with the surface that triggered it.
// Not reactive on purpose (read at click time).
let appBannerSource = null
let listeners = []

const setAppBannerState = (type) => {
    appBannerType = type
    listeners.forEach(listener => listener(appBannerType))
}

const subscribe = (listener) => {
    listeners.push(listener)
    return () => {
        listeners = listeners.filter(l => l !== listener)
    }
}


export const useAppBanner = () => {
    const [bannerType, setBannerType] = useState(appBannerType)

    useEffect(() => {
        const unsubscribe = subscribe(setBannerType)
        return () => unsubscribe()
    }, []);

    return bannerType
}

export const getAppBannerSource = () => appBannerSource

export const toggleAppBanner = (type, source = null, { escalate = true } = {}) => {
    // Escalate straight to the pricing modal only when an explicit user action
    // re-triggers the SAME Free-tier banner that's already open (re-showing the
    // identical banner reads as "nothing happened"). Programmatic/effect
    // triggers pass escalate:false, so merely landing on a surface whose banner
    // is already up never auto-opens the pricing dialog.
    if (escalate && type && type === appBannerType && type.startsWith('free-')) {
        AnalyticsService.track('clicked_upgrade_from_limit', { source: source || type })
        togglePricingPlansDialog(true)
        return
    }

    appBannerSource = source
    setAppBannerState(type)
}
